module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout', {
    staticClass: "min-h-dvh flex flex-col"
  }, [_c('app-header', {
    staticClass: "bg-gradient-to-b from-secondary to-primary pb-8"
  }), _vm._v(" "), _c('nav', {
    staticClass: "bg-gradient-to-b from-[#F8FBFF] to-[#E2E9F5] rounded-t-[1.5rem] relative z-20 isolate shadow-xl -mt-6 px-2 flex-1 overflow-y-auto"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "w-full h-[calc(100vh-180px)] rounded-b-3xl shadow-md grid place-items-center"
  }, [_c('span', {
    staticClass: "text-primary/70"
  }, [_vm._v("Chargement du support…")])]) : (_vm.error) ? _c('div', {
    staticClass: "w-full h-[calc(100vh-180px)] rounded-b-3xl shadow-md grid place-items-center"
  }, [_c('div', {
    staticClass: "text-center px-6"
  }, [_c('p', {
    staticClass: "text-red-600 font-semibold mb-2"
  }, [_vm._v("Impossible d’ouvrir le support")]), _vm._v(" "), _c('p', {
    staticClass: "text-primary/70 mb-4"
  }, [_vm._v("Aucun token n’a été trouvé pour cet utilisateur.")]), _vm._v(" "), _c('router-link', {
    staticClass: "underline text-primary",
    attrs: {
      "to": "/home"
    }
  }, [_vm._v("Retour à l’accueil")])], 1)]) : _c('object', {
    staticClass: "w-full h-[calc(100vh-200px)] rounded-b-3xl shadow-md",
    attrs: {
      "id": "supportObject",
      "type": "text/html",
      "data": _vm.supportUrl
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d4266ba","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/Support.vue
// module id = 1013
// module chunks = 0